@if (call$ | async; as result) {
  @if (result.isPending) {
    <app-spinner></app-spinner>
  } @else if (result.isError) {
    <h2 class="failed-to-load" translate="COMMON.FAILED_TO_LOAD"></h2>
  } @else {
    @if (result.data; as call) {
      <div class="page-container">
        <app-toolbar [title]="call.name" [backButtonLink]="getBackButtonLink(call)" [showAdminButton]="true">
          <app-call-details-bar class="details" [call]="call" [templateItems]="(templateItems$ | async) ?? []"></app-call-details-bar>
        </app-toolbar>
        <div class="page">
          <div class="wrapper">
            @if (currentUser$ | async; as user) {
              <app-call-setup [call]="call" [metadata]="call.agendaMetadata" [organization]="user.organization"></app-call-setup>
            }
          </div>
        </div>
      </div>
    }
  }
}
